import React from 'react';
import {
  Footer,
  QuestionContainer,
  Header,
  Body,
  ValueText,
  Title,
  QuestionText,
  LabelText,
  FooterText,
  Separator,
  QuestionTextDiv,
} from './styles';

interface Props {
  cardQuestion: any;
}

const CardStyleQuestionSummary: React.FC<Props> = ({ cardQuestion }) => {
  const { options } = cardQuestion.question;
  const minOption = options.reduce(
    (min: any, option: any) => (option.value < min.value ? option : min),
    options[0],
  );
  const maxOption = options.reduce(
    (max: any, option: any) => (option.value > max.value ? option : max),
    options[0],
  );
  const isLargeScale = options.length > 10;
  const matchedOption = options.find(
    (option: any) => option.text === cardQuestion.result.optionText,
  );
  const hasAnswer =
    cardQuestion.result?.value !== undefined &&
    cardQuestion.result?.value !== null &&
    cardQuestion.result?.value !== '';

  const getQuestionText = (): string => {
    const { questionIdComplete, question } = cardQuestion;

    if (!questionIdComplete.includes('.')) {
      return question.text;
    }

    const alternativeId = Number(questionIdComplete.split('.')[1]);
    const alternative = question.alternatives.find(
      (item: any) => item.value === alternativeId,
    );

    return alternative?.text;
  };

  return (
    <QuestionContainer id="card-question">
      <Header id="card-header">
        <Title id="card-title">{cardQuestion.mainCardTitle}</Title>
        <QuestionTextDiv>
          <QuestionText>
            {cardQuestion.customQuestionText !== ''
              ? cardQuestion.customQuestionText
              : getQuestionText()}
          </QuestionText>
        </QuestionTextDiv>
      </Header>
      <Separator />
      <Body id="card-body">
        <ValueText $isNoAnswer={!hasAnswer}>
          {!hasAnswer
            ? 'Keine Antwort'
            : isLargeScale
            ? matchedOption?.text
            : cardQuestion.result.value}
        </ValueText>
        <LabelText>
          {hasAnswer && !isLargeScale ? cardQuestion.result.optionText : ''}
        </LabelText>
      </Body>
      <Separator />
      <Footer id="card-footer">
        <FooterText>{`Skala: ${
          isLargeScale
            ? minOption.text
            : `${minOption.value} = ${minOption.text}`
        } | ${
          isLargeScale
            ? maxOption.text
            : `${maxOption.value} = ${maxOption.text}`
        }`}</FooterText>
      </Footer>
    </QuestionContainer>
  );
};

export default CardStyleQuestionSummary;
